import '../Styles/DownloadPDFButton.css'

const DownloadPDFButton = ({ onDownload }) => {
    return (
        <div className='d-flex justify-content-center'>
        <button className="download-btn d-flex" onClick={onDownload}>
            Download PDF
        </button>
        </div>
    );
}

export default DownloadPDFButton;